import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './assets/styles/globalStyles.css';
import { MemoryRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import Providers from './components/Providers.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import CookieConsentPortal from './components/common/cookies/CookieConsentPortal.jsx';
import disableConsoleLogs from './utils/disableConsoleLogs.js';

const isProduction = import.meta.env.MODE === 'production';
if (isProduction) disableConsoleLogs();
// index.js or App.js

registerSW();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MemoryRouter>
      <Providers>
        <ErrorBoundary>
          <App />
          {isProduction && <CookieConsentPortal />}
        </ErrorBoundary>
      </Providers>
    </MemoryRouter>
  </React.StrictMode>,
);
